// src/plugins/loading.js
import Vue from "vue";
import Loading from "../components/cards/VueLoading.vue";

const loading = {
  install(Vue) {
    const LoadingConstructor = Vue.extend(Loading);
    const loading = new LoadingConstructor();
    loading.$mount(document.createElement("div"));
    document.body.appendChild(loading.$el);

    Vue.prototype.$loading = {
      start: () => loading.start(),
      stop: () => loading.stop(),
    };
  },
};

export default loading;
